/**
 *
 * SectionWrapper
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import _ClassNames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: {
    background: '#fff',
    padding: '35px 25px',
    marginTop: ({ top }) => top,
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      padding: 20,
    },
  },
  bottomMargin: {
    marginBottom: 21,
  },
}));

function SectionWrapper(props) {
  const { children, bottom, top = 21 } = props;
  const classes = useStyles({ top });
  return (
    <div
      className={_ClassNames(
        classes.root,
        bottom ? classes.bottomMargin : undefined,
      )}
    >
      {children}
    </div>
  );
}

SectionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  bottom: PropTypes.number,
  top: PropTypes.number,
};

export default SectionWrapper;
